import { render, staticRenderFns } from "./StoreSalesProductRegistration.vue?vue&type=template&id=215050ea&scoped=true&"
import script from "./StoreSalesProductRegistration.vue?vue&type=script&lang=js&"
export * from "./StoreSalesProductRegistration.vue?vue&type=script&lang=js&"
import style0 from "./StoreSalesProductRegistration.vue?vue&type=style&index=0&id=215050ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215050ea",
  null
  
)

export default component.exports